import type { PersonAPI } from './person-api.types';

export function mapPartnerUserListItem(item: PersonAPI.PartnerUserListItemHttp): PersonAPI.PartnerUser {
  return {
    active: item.active,
    email: item.username,
    fullName: item.fullname,
    id: item.id,
    mobile: item.mobile ?? item.contact?.mobile ?? '',
    profile: item.profile,
  };
}

export function mapPartnerUsersListResponse(
  response: PersonAPI.PartnerUsersListResponseHttp,
  page: number,
  pageSize: number,
): PersonAPI.PartnerUsersPage {
  const hasNext = response.has_next ?? (page * pageSize < response.count);

  return {
    count: response.count,
    data: response.data.map(mapPartnerUserListItem),
    hasNext,
  };
}
